module.exports = __webpack_public_path__ + "img/look.cee11d2b.png";